import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import "./conversation.scss";
import { UserAvatar, ProgressLoader, Popup, Message, MessageComposer, LazyLoadingWithPagination } from "components/shared";
import { FlapHeader } from "components/layout";
import { TaskService } from "services/http/";
import { SocketContext } from 'services/';
import jwtWorker from 'utils/jwt-worker';
import utils, { INTERVENTION_STATUS, MESSAGE_DIRECTION } from 'utils';
import { TasksRightSide } from 'components/pages';
import { useHistory } from 'react-router';


export function Conversation(props) {

    const [chats, setChats] = useState([]);
    const [currentTask, setCurrentTask] = useState(JSON.parse(new URLSearchParams(window.location.search).get('task')));
    const history = useHistory();
    const { interventionId: roomId } = currentTask;
    let { client: customer } = currentTask;
    customer['username'] = `${customer?.firstname} ${customer?.lastname}`;
    const socketContext = useContext(SocketContext);
    const agentUsername = jwtWorker.getSubFromToken();
    let shouldComposerDisplay = (currentTask?.status.statusId === INTERVENTION_STATUS.ACCEPTED || currentTask?.status.statusId === INTERVENTION_STATUS.IN_PROGRESS || currentTask?.status.statusId === INTERVENTION_STATUS.DEFFERRED);
    const [callback, setCallback] = useState();
    let chatSubscription;
    const composerMessageRef = useRef();

    useEffect(() => {
        setChats(utils.sortArrayObjectByDateASC(props.data.messages, ["sendDate"]))
    }, [props.data.messages])

    useEffect(() => {
        let intervention = JSON.parse(new URLSearchParams(history.location.search).get('task'));
        intervention && setCurrentTask(intervention);
    }, [history.location.search]);

    useEffect(() => {
        //SUBSCRIBE TO THE CHAT TOPIC
        async function stompPromise() { return await socketContext.getStompClient(); }
        stompPromise().then((stomp) => {
            chatSubscription = stomp.subscribe(`${process.env.REACT_APP_SOCKET_CHAT_TOPIC}${roomId}`, callbackRecieve);
        });
        utils.scrollChatContainerToBottom();
        return () => { chatSubscription && chatSubscription.unsubscribe() }
    }, [roomId]);


    //ON RECIEVE CALLBACK BROADCAST
    const callbackRecieve = (data) => {
        let payload = JSON.parse(data.body);
        setCallback(payload);
        composerMessageRef?.current.manageMessageProgressStatus(false);
    }

    //SEND MESSAGE OVER SOCKET-CONTEXT
    const sendSocketEvent = (payload) => {
        composerMessageRef?.current.manageMessageProgressStatus(true);
        socketContext.sendMessage({ destination: process.env.REACT_APP_SOCKET_SEND_CHAT + roomId, payload });
    }

    //FIX HEIGHT SIZE OVERLAPPING
    utils.fixComposerOverlpping();

    useEffect(() => {
        const payload = callback;
        if (payload) {
            switch (payload.type) {
                case BROADCAST_TYPES.CHAT_BROADCAST: {
                    if (payload.messageBody.intervention == roomId) {
                        if (!payload.messageBody.reaction) {
                            setChats((chats) => [...chats, payload.messageBody]);
                        } else {
                            setChats(chats.map((item) => {
                                return (item.messageId === payload.messageBody.messageId)
                                    ? payload.messageBody : item;
                            }));
                        }
                    }
                    break;
                }
                case BROADCAST_TYPES.ERROR_BROADCAST: {
                    if (payload.messageBody.intervention == roomId) {
                        let messageError = payload.messageBody;
                        messageError["error"] = true;
                        messageError["descriptionError"] = payload.description;
                        setChats((chats) => [...chats, messageError]);
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }
        //SCROLLING TO THE END
        utils.scrollChatContainerToBottom();

    }, [callback]);


    return (
        <div className="root-conversation">

            <div className="conversation-scroll">
                {props.children}
                {
                    chats.map((chat) =>
                        <Message
                            msgId={chat.messageId}
                            mine={chat.direction === MESSAGE_DIRECTION.OUTGOING ? true : false}
                            author={chat.direction === MESSAGE_DIRECTION.OUTGOING ? SENDER_TYPES.AGENT : customer.username}
                            message={chat.content}
                            avatarImage={chat.direction === MESSAGE_DIRECTION.INCOMING ? customer.profilePic : null}
                            avatarLabel={chat.direction === MESSAGE_DIRECTION.OUTGOING ? chat.username?.substring(0, 2).toUpperCase() : null}
                            avatarIcon={(chat.direction === MESSAGE_DIRECTION.OUTGOING && chat.username === null) ? utils.guessSourceIcon(currentTask.source.sourceId) : null}
                            time={new Date(chat.sendDate).toLocaleString()}
                            withAttachment={chat.withAttachment === 1}
                            attachments={chat.attachments}
                            reaction={chat.reaction ? chat.emoji : null}
                            errorChat={{ error: chat.error, description: chat.descriptionError }}
                        />
                    )
                }
                {
                    currentTask.lastSeen &&
                    <small className="px-3 inline-center last-seen">
                        <hr className="hr-text" data-content={`👁 Last seen : ${new Date(currentTask.lastSeen).toLocaleString()}`} />
                    </small>
                }

            </div>
            {
                <MessageComposer
                    ref={composerMessageRef}
                    displayed={shouldComposerDisplay}
                    sendEvent={(message) => {
                        sendSocketEvent({
                            messageBody: {
                                content: message,
                                from: SENDER_TYPES.CONSOLE,
                                username: agentUsername
                            },
                            type: BROADCAST_TYPES.CHAT_BROADCAST
                        })
                    }}
                    sendAttachement={(base64Conversion) => {
                        sendSocketEvent({
                            messageBody: {
                                content: null,
                                from: SENDER_TYPES.CONSOLE,
                                username: agentUsername,
                                withAttachement: 1,
                                attachmentBase64: base64Conversion.conversion,
                                attachmentExtension: base64Conversion.extension
                            },
                            type: BROADCAST_TYPES.CHAT_BROADCAST
                        })
                    }}
                />
            }
        </div >
    );
}

//CHAT BROADCASTS TYPES
export const BROADCAST_TYPES = {
    CHAT_BROADCAST: "CHAT",
    ERROR_BROADCAST: "error",
}

export const SENDER_TYPES = {
    CONSOLE: "console",
    AGENT: "Agent"
}

export const ConversationHoc = (props) => {

    const { task } = props;
    const { client: customer } = task;
    customer["username"] = `${customer.firstname} ${customer.lastname}`;
    const [displayCustomerChipDialog, setDisplayCustomerChipDialog] = useState(false);

    const ConversationMemoHoc = useMemo(() => LazyLoadingWithPagination(
        Conversation,
        TaskService.getLazyMessages,
        { interventionId: task.interventionId, pageIndex: 0 },
        "messages",
        <ProgressLoader container />)(props), [task.interventionId]);

    return <>
        <FlapHeader
            leftSide={
                <div className="my-1 d-flex">
                    <UserAvatar image={customer.profilePic} size="small" shape="circle" />
                    <span className="my-1">&nbsp; Conversation -
                        {
                            props.folderView ?
                                <a href="/"
                                    style={{ color: "white" }}
                                    className="customer-shortlink"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setDisplayCustomerChipDialog(true);
                                    }}> {customer.username} <i className="bi bi-arrow-up-right-circle" style={{ fontSize: "14px" }} /></a>
                                : <> {customer.username} </>
                        }
                    </span>
                    <Popup
                        sticked
                        visible={displayCustomerChipDialog}
                        onHide={() => setDisplayCustomerChipDialog(false)} >
                        <TasksRightSide task={task} />
                    </Popup>
                </div>
            }
            rightSide={
                <a href={process.env.REACT_APP_FB_PAGE_TEMP_URL} className="my-1" target="_blank" rel="noreferrer">
                    <i className={task.source.sourceId === "messenger" && "bi bi-facebook"} style={{ fontSize: "25px", color: "white" }} />
                </a>
            } />
        <ConversationMemoHoc />
    </>
}
